import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { ProcessDesignerUIState } from '../../../../app/process-designer.uistate';
import { DatagridComponent } from '@farris/ui-datagrid';
import { CustomizeAciton } from '../../entities/customize-action.entity';
import { ActualParameter } from '../../../execute-forms/entities/execute-form.entity';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../../i18n/assets/lang.resource';

@Component({
  selector: 'app-customize-action-list',
  templateUrl: './customize-action-list.component.html',
  styleUrls: ['./customize-action-list.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class CustomizeActionListComponent implements OnInit {

  @ViewChild('grid') grid: DatagridComponent;
  @ViewChild('footer') footer: TemplateRef<any>;

  @Output() submit = new EventEmitter<any[]>();
  @Output() cancel = new EventEmitter<any>();

  customActionList: any[];

  private terminalList = [
    { value: 'app', text: this.localePipe.transform('component.customizeAction.app') },
    { value: 'web', text: 'web' },
    { value: 'web,app', text: this.localePipe.transform('component.customizeAction.all') }
  ];

  cols = [
    { field: 'code', width: 100, title: this.localePipe.transform('component.customizeAction.code') },
    { field: 'name', width: 100, title: this.localePipe.transform('component.customizeAction.name') },
    {
      field: 'terminal', width: 100, title: this.localePipe.transform('component.customizeAction.terminalType'),
      formatter: {
        type: 'enum',
        options: { valueField: 'value', textField: 'text', data: this.terminalList }
      }, },
    {
      field: 'isAll', width: 100, title: this.localePipe.transform('component.customizeAction.isAll'),
      formatter: { type: 'boolean', options: { trueText: this.localePipe.transform('component.customizeAction.yes'), falseText: this.localePipe.transform('component.customizeAction.no') } }  }
  ];
  constructor(
    private designerUIState: ProcessDesignerUIState,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    this.customActionList = this.designerUIState.flowFormInfo.customizeActions || [];
  }

  ngOnInit() {
  }
  clickOK() {
    const selections = [];
    const checkeds: any[] = this.grid.checkeds;
    if (checkeds && checkeds.length > 0) {
      checkeds.forEach(action => {
        const item = new CustomizeAciton(action.data.id, action.data.code, action.data.name);
        item.terminalType = action.data.terminal;
        // item.enable = true;
        item.actualParameters = [];
        if (action.data.actualParameters && action.data.actualParameters.length > 0) {
          for (const p of action.data.actualParameters) {
            const param = {
              Name: p.code,
              Value: p.value,
              ValueText: p.name,
              Tag: 'expression'
            } as ActualParameter;
            item.actualParameters.push(param);
          }
        }
        selections.push(item);
      });
    }
    this.submit.emit(selections);
  }
  clickCancel() {
    this.cancel.emit(true);
  }
}
